import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { tryCatch } from '@/redux/thunks/shared/try-catch';

export const checkIncompatibleProductsFromCheckout = createAppAsyncThunk(
  'checkout/checkIncompatibleProducts',
  async (_, { getState, rejectWithValue, extra: { checkoutService } }) => {
    const { data, error } = await tryCatch(
      checkoutService.checkIncompatibleProducts({ storeId: getState().root.storeConf.storeId })
    );

    if (error) {
      return rejectWithValue(error);
    }
    return data;
  }
);
